export const NO_RECONFIGURATION = "no_reconfiguration";

export const RECONFIGURATION_STARTED = "started";

export const isReconfigurationInProgress = (
  reconfigurationState: string
): boolean => {
  return reconfigurationState !== NO_RECONFIGURATION;
};
